
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Реклама / Дизайн / Фотография
            </div>
            <p className="text-gray-400">
              Комплексные услуги по продвижению, визуальному оформлению и производству материалов для вашего бизнеса.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Наши услуги</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Маркетинговая стратегия
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Дизайн и брендинг
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Производство и фото
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Навигация</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  О нас
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('company-details')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Реквизиты
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Контакты
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 ИП Костина Е.В. Все права защищены.</p>
        </div>
      </div>
    </footer>
  );
}
